import { ApplicationDetailsComponent } from './components/application-details/application-details.component';
import { ApplicationMainPanelComponent } from './components/application-main-panel/application-main-panel.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouteGuard } from 'src/app/core/route-guards/route-guard.guard';

import { ApplicationSummaryComponent } from './components/application-summary/application-summary.component';
import { ApplicationParentListComponent } from './components/application-parent-list/application-parent-list.component';
import { UserRoleNames } from 'src/app/core/models/users';
import { ActionLogsComponent } from '../shared/components/actionlogs-component/action-logs.component';

const routes: Routes = [
  {
    path: 'Applications List',
    component: ApplicationParentListComponent,
    canActivate: [RouteGuard],
    data: { role: [UserRoleNames.GlobalAdmin] },
  },
  {
    path: 'Applications List/:cloudType/:deploymentName',
    component: ApplicationMainPanelComponent,
    canActivateChild: [RouteGuard],
    children: [
      {
        path: 'Applications',
        component: ApplicationSummaryComponent,
        children: [
          {
            path: ':appName/:appVersion',
            component: ApplicationDetailsComponent,
          },
        ],
      },
      {
        path: 'Logs',
        component: ActionLogsComponent,
      },
      { path: '', pathMatch: 'full', redirectTo: 'Applications' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class ApplicationRoutingModule {}
